module.exports = __webpack_public_path__ + "static/media/visa-logo.d19302db.svg";